<template>
  <legal-page>
    <h1>《宇宙之幂》隐私保护政策</h1>
    <div class="legal-page__meta">
      <p>更新日期：2026 年 7 月 22 日</p>
      <p>生效日期：2026 年 7 月 22 日</p>
    </div>

    <p>宇宙之幂（深圳）科技集团有限公司及其依法设立的关联公司、子公司（以下简称“我们”）是《宇宙之幂》移动应用程序及相关服务（以下简称“本应用”或“本服务”）的运营者。我们非常重视您的个人信息和隐私保护，并会遵循合法、正当、必要、诚信和最小必要原则处理您的个人信息。</p>
    <p>请您在使用本应用前仔细阅读并充分理解本政策，尤其是以 <strong>加粗</strong> 方式提示您注意的敏感个人信息、系统权限和第三方 SDK 相关内容。您点击“同意”后，表示您已阅读、理解并同意本政策。如果您不同意本政策，可以点击“拒绝”并退出本应用。</p>

    <section>
      <h2>一、本政策的适用范围</h2>
      <p>本政策适用于我们通过《宇宙之幂》Android 客户端及其中的账号、智能交互、语音输入与播报、场景模拟、内容生成、摄像头扫描、地图定位与导航、图片或文件上传、音频播放、问题反馈等功能向您提供的产品和服务。</p>
      <p>当您通过本应用访问第三方网页、服务或内容时，第三方可能按照其单独的用户协议和隐私政策处理您的信息。请您在使用前仔细阅读第三方的相关规则。</p>
    </section>

    <section>
      <h2>二、我们如何收集和使用您的个人信息</h2>
      <p>我们会根据您实际使用的功能处理必要的个人信息。您可以选择不提供非基本功能所必需的信息，或拒绝相应系统权限；这可能导致对应功能无法使用，但不影响其他不依赖该信息或权限的功能。当某个场景功能需要多项权限共同完成时，如您未完整授权，该场景可能无法进入。</p>

      <h3>2.1 账号注册、登录与管理</h3>
      <ol>
        <li>当您使用手机号码登录或注册时，我们会收集您的 <strong>手机号码、短信验证码</strong>，用于完成账号注册、登录、身份验证和账号安全保护。</li>
        <li>当您选择密码登录时，我们会处理您输入的 <strong>手机号码和账号密码</strong>，用于验证账号身份。请您妥善保管账号凭证，不要向他人透露密码或验证码。</li>
        <li>当您选择微信登录时，我们会在您确认授权后获取微信返回的 <strong>登录授权代码</strong>，并可能获取您授权的微信账号标识、昵称和头像，用于完成第三方账号登录、账号关联或绑定。</li>
        <li>在您使用账号后，我们会处理您的用户 ID、账号名称、头像、微信绑定状态、账号状态、虚拟资产或余额信息，用于展示用户资料、保存账号下的业务内容和维护账号安全。</li>
      </ol>

      <h3>2.2 智能交互、指令解析与内容生成</h3>
      <p>当您通过文字、语音、按钮或其他交互方式使用智能交互、信息查询、场景模拟、宇宙生成、原地生成、内容推荐或其他生成功能时，我们会收集和使用您提交的 <strong>文字或语音指令、问题内容、交互上下文、业务场景标识、用户 ID 和 Android ID</strong>，用于识别您的指令、请求服务端返回结果、维持交互会话以及展示或播报结果。</p>
      <p>请您不要在交互指令中提交与功能无关的身份证件号码、银行账号、账号密码、验证码或其他敏感信息。如您的指令中包含他人个人信息，请确保您已获得相关个人的合法授权。</p>

      <h3>2.3 语音输入、语音识别与语音播报</h3>
      <p>当您主动使用语音交互、原地模拟、场景模拟、原地生成、宇宙生成、面试模拟或其他需要录音的功能时，我们会先向您说明用途并申请 <strong>麦克风权限</strong>。获得授权后，我们及语音技术服务提供方会处理您的 <strong>语音、音频数据及识别后的文字</strong>，用于将语音转换为指令、返回识别结果或播放语音回复。</p>
      <p>您拒绝麦克风权限后，我们不会启动录音，相关语音功能将无法使用。本应用产生的临时音频或识别缓存会保存在应用专属目录中，并在不再需要时删除或由系统根据缓存管理规则清理。</p>

      <h3>2.4 地图、定位与导航</h3>
      <p>当您主动进入地图弹窗、查看当前位置、选择地理坐标、使用附近信息或请求导航时，我们会先说明用途并申请 <strong>粗略位置或精确位置权限</strong>。获得授权后，我们及地图服务提供方可能处理您的 <strong>经纬度、定位精度、所在城市、省份、地址、附近兴趣点、导航起终点、路线和位置服务相关的设备及网络信息</strong>，用于展示地图、定位您的位置、保存您主动选择的业务坐标、搜索附近地点和规划导航路线。</p>
      <p>位置信息属于敏感个人信息。您可以拒绝授权或在系统设置中关闭位置权限，关闭后我们将无法向您提供基于当前位置的地图和导航功能。</p>

      <h3>2.5 摄像头扫描、二维码和图像识别</h3>
      <p>当您主动使用扫码、宇宙扫描、场景识别、物体或图像识别、面试模拟或其他需要拍摄的功能时，我们会先说明用途并申请 <strong>摄像头权限</strong>。获得授权后，我们可能处理摄像头采集的 <strong>图像、视频画面、二维码或条形码内容及识别结果</strong>，用于完成对应的扫描或识别功能。</p>
      <p>二维码识别可在设备本地完成；当您主动使用在线图像识别、图片上传或生成功能时，相关图片可能会上传至我们的服务器进行处理。请您避免拍摄或上传与功能无关的身份证件、银行卡、他人面部或私密场景。</p>

      <h3>2.6 电话、短信和通讯录指令</h3>
      <p>当您在模拟或语音交互场景中主动发出“拨打电话”或“发送短信”等指令时，本应用可能申请 <strong>读取通讯录、拨打电话、发送短信和读取电话状态权限</strong>。在获得授权后：</p>
      <ol>
        <li>我们会根据您指定的联系人姓名，在设备本地通讯录中查找对应的 <strong>联系人姓名和电话号码</strong>，用于完成您指定的拨号或短信操作。</li>
        <li>拨打电话功能会调用系统电话能力；短信功能会打开系统短信编辑页并预填您指定的号码和内容，由您在系统页面确认后发送。</li>
        <li>我们不会为了该功能读取您的通话内容、通话记录或历史短信内容。</li>
      </ol>
      <p>通讯录信息和通信内容属于敏感个人信息。请您仅在已获得相关联系人授权或具备其他合法基础时使用该功能。</p>

      <h3>2.7 图片、文件上传和用户创建内容</h3>
      <p>当您主动选择、拍摄或上传图片、文档、资质材料或其他文件，或创建形象、场景、星球、知识、能力及其他内容时，我们会处理您主动提交的 <strong>文件或图片内容、文件名称、内容名称与描述、业务坐标、价格或其他表单信息、用户 ID</strong>，用于上传、保存、展示和管理您创建的内容。</p>
      <p>在旧版 Android 系统中，为读取您主动选择的本地图片或文件，本应用可能申请 <strong>读取存储空间权限</strong>。对于应用自身产生的文件，我们优先使用应用专属目录，不因为保存自身文件而申请外部存储写入权限。</p>

      <h3>2.8 音频内容播放</h3>
      <p>当您使用在线音频、电台或其他音频播放功能时，我们可能处理您的 <strong>播放、暂停、切换、搜索和收听请求，以及必要的网络连接信息</strong>，用于获取音频内容并完成播放控制。</p>

      <h3>2.9 问题反馈、客户服务与账号注销</h3>
      <ol>
        <li>当您提交问题反馈时，我们会收集您的 <strong>用户 ID、问题描述、您主动上传的图片、反馈时间和处理状态</strong>，用于查询、定位和处理您反馈的问题。</li>
        <li>当您通过客服或邮件联系我们时，我们会处理您主动提供的联系方式、咨询或投诉内容和必要的账号核验信息，用于回复您的请求并保障账号安全。</li>
        <li>您可以进入应用“首页”，点击页面中央的球形主功能入口，在展开的功能球中依次点击“支持—用户中心—用户设置—注销账号”，进入账号注销页面。请确认账号由您本人拥有且处于安全状态，并已处理未完成业务及账号资产；阅读并同意《账号注销须知》后，按照页面提示进行操作。当前在线注销服务暂未开通，如需申请注销，可以通过注销页面的“联系客服”入口或本政策第十三条载明的联系方式联系我们。为保护账号安全，我们可能需要验证您的账号身份。</li>
      </ol>

      <h3>2.10 设备、网络、运行与安全信息</h3>
      <p>为了保障服务的正常运行、识别交互请求、适配设备、诊断故障和保护账号及网络安全，我们可能处理以下信息：</p>
      <ul>
        <li><strong>Android ID、应用包名、用户 ID</strong>：用于识别设备端的业务请求、返回匹配的交互内容和进行必要的安全校验。</li>
        <li><strong>IP 地址、网络类型、网络连接状态、Wi-Fi 连接状态</strong>：用于连接服务器、判断网络可用性、定位网络故障和保障服务安全。</li>
        <li><strong>设备型号、操作系统版本、应用版本、运行状态、异常堆栈和错误日志</strong>：用于设备适配、排查崩溃和改善稳定性。应用自身生成的崩溃日志优先保存在应用专属目录中。</li>
      </ul>
      <p>我们不会将上述信息用于与提供本服务无关的用户画像或精准营销。</p>

      <h3>2.11 应用更新与安装</h3>
      <p>当您主动确认下载和安装应用新版本时，我们可能使用网络访问、文件下载和 <strong>安装未知应用权限</strong> 完成更新。我们会在您主动选择更新时调起系统授权或安装页面，您可以取消安装。</p>
    </section>

    <section>
      <h2>三、系统权限使用说明</h2>
      <p>系统权限不会因您同意本政策而自动授予。对于录音、定位、摄像头、通讯录等敏感权限，我们会在您主动进入对应功能时另行说明用途并请求系统授权。</p>
      <div class="legal-page__table">
        <table>
          <thead>
            <tr>
              <th>系统权限</th>
              <th>使用场景和目的</th>
              <th>拒绝后的影响</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>麦克风 <code>RECORD_AUDIO</code></td>
              <td>语音交互、语音识别、模拟和生成类功能</td>
              <td>无法录入语音或进入依赖录音的场景</td>
            </tr>
            <tr>
              <td>粗略/精确位置 <code>ACCESS_COARSE_LOCATION</code> / <code>ACCESS_FINE_LOCATION</code></td>
              <td>地图展示、当前位置、附近信息、坐标选择和导航</td>
              <td>无法使用需要当前位置的地图或导航功能</td>
            </tr>
            <tr>
              <td>摄像头 <code>CAMERA</code></td>
              <td>扫码、宇宙扫描、场景/图像识别和面试模拟</td>
              <td>无法使用需要拍摄的功能</td>
            </tr>
            <tr>
              <td>读取通讯录 <code>READ_CONTACTS</code></td>
              <td>根据您的指令在本地查找联系人和号码</td>
              <td>无法通过联系人姓名执行拨号或短信指令</td>
            </tr>
            <tr>
              <td>拨打电话 <code>CALL_PHONE</code></td>
              <td>执行您主动发出的拨号指令</td>
              <td>无法从应用内发起拨号</td>
            </tr>
            <tr>
              <td>发送短信 <code>SEND_SMS</code></td>
              <td>处理您主动发出的短信指令；当前主要调起系统短信编辑页</td>
              <td>无法使用对应短信指令</td>
            </tr>
            <tr>
              <td>读取电话状态 <code>READ_PHONE_STATE</code></td>
              <td>电话指令场景下的设备能力判断和兼容适配</td>
              <td>可能无法进入需要完整通信能力的模拟场景</td>
            </tr>
            <tr>
              <td>读取存储空间 <code>READ_EXTERNAL_STORAGE</code></td>
              <td>在旧版 Android 系统中读取您主动选择的图片或文件</td>
              <td>无法从本地选择和上传相关文件</td>
            </tr>
            <tr>
              <td>显示在其他应用上层 <code>SYSTEM_ALERT_WINDOW</code></td>
              <td>在您主动开启悬浮交互功能时显示悬浮内容</td>
              <td>无法使用悬浮层形式的交互功能</td>
            </tr>
            <tr>
              <td>安装未知应用 <code>REQUEST_INSTALL_PACKAGES</code></td>
              <td>您主动下载并安装新版本</td>
              <td>无法从应用内完成新版本安装</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>您可以在系统“设置—应用—宇宙之幂—权限”中查看、开启或关闭已授予的系统权限。撤回授权不影响撤回前基于您同意已进行的个人信息处理活动的效力。</p>
    </section>

    <section>
      <h2>四、第三方 SDK 与信息共享</h2>
      <p>为实现地图、语音和微信登录等功能，我们会接入第三方 SDK。我们会在您同意本政策后再通过应用的统一入口初始化相关业务 SDK；对于依赖系统权限的具体功能，还会在您主动使用时另行请求授权。</p>
      <div class="legal-page__table">
        <table>
          <thead>
            <tr>
              <th>SDK 名称</th>
              <th>服务提供方</th>
              <th>使用目的</th>
              <th>可能处理的信息</th>
              <th>信息处理规则</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>高德地图、定位、搜索及导航 SDK</td>
              <td>北京高德图强科技有限公司</td>
              <td>地图展示、定位、附近搜索和导航</td>
              <td><strong>经纬度、精确位置、设备信息、Android ID、网络信息、Wi-Fi 信息、传感器信息、IP 地址及地图/导航操作信息</strong>，具体以实际 SDK 版本和官方规则为准</td>
              <td><a href="https://developer.amap.com/pages/privacy/" target="_blank" rel="noopener noreferrer">高德地图开放平台隐私权政策</a></td>
            </tr>
            <tr>
              <td>科大讯飞语音 SDK</td>
              <td>科大讯飞股份有限公司</td>
              <td>语音识别、语音合成和语音交互</td>
              <td><strong>语音或音频数据、识别文本、IP 地址、Android ID、IMEI、IMSI、OAID、设备序列号、应用列表、网络及设备信息</strong>，具体以实际语音能力和官方规则为准；本应用已关闭讯飞 SDK 的位置信息采集开关</td>
              <td><a href="https://www.xfyun.cn/doc/policy/privacy.html" target="_blank" rel="noopener noreferrer">讯飞开放平台隐私政策</a>、<a href="https://www.xfyun.cn/doc/total_sdk_privacy/total_privacy.html" target="_blank" rel="noopener noreferrer">SDK 隐私政策总览</a></td>
            </tr>
            <tr>
              <td>微信 OpenSDK</td>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>微信授权登录、账号绑定和授权结果回传</td>
              <td><strong>登录授权代码、微信账号标识、昵称、头像（以您授权的范围为准）、设备及网络信息</strong></td>
              <td><a href="https://privacy.tencent.com/" target="_blank" rel="noopener noreferrer">腾讯隐私保护平台</a>、<a href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&amp;t=weixin_agreement&amp;s=privacy" target="_blank" rel="noopener noreferrer">微信隐私保护指引</a></td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>除上述功能所必需的共享外，我们不会向其他公司、组织或个人出售您的个人信息。如果未来新增需要共享个人信息的第三方服务，我们会更新本政策或第三方共享清单，并在依法需要时另行征得您的同意。</p>
      <p>在以下情形中，我们可能依据法律法规的规定处理或提供必要的个人信息，而无需另行征得您的同意：为订立、履行您作为一方当事人的合同所必需；为履行法定职责或法定义务所必需；为应对突发公共卫生事件，或在紧急情况下保护自然人的生命健康和财产安全所必需；在合理范围内处理您自行公开或其他已经合法公开的个人信息；以及法律、行政法规规定的其他情形。</p>
    </section>

    <section>
      <h2>五、我们如何使用 Cookie 和类似技术</h2>
      <p>本应用的原生功能主要使用本地存储和账号状态信息记录您的登录状态、隐私政策同意状态和功能偏好，以便完成账号登录、保持功能设置和减少重复操作。</p>
      <p>当您在本应用内打开网页时，相关网页可能使用 Cookie、Web Storage 或类似技术保障网页正常展示、记录会话状态和保护访问安全。具体处理规则以对应网页的隐私说明为准。</p>
    </section>

    <section>
      <h2>六、个人信息的保存</h2>
      <ol>
        <li>我们会在为您提供服务所必需的最短期限内保存您的个人信息。法律法规对保存期限另有规定的，我们将按照相关规定处理。</li>
        <li>账号存续期间，我们会保存为提供账号服务所需的账号资料和业务内容。在您注销账号或超出必要保存期限后，我们将依法删除或匿名化处理相关个人信息，但法律法规要求继续保存的除外。</li>
        <li>通过中国大陆地区提供本服务收集的个人信息，原则上将保存在中国大陆境内。如未来确需向境外提供您的个人信息，我们将按照法律法规履行相应义务，并在需要时征得您的单独同意。</li>
      </ol>
    </section>

    <section>
      <h2>七、我们如何保护您的个人信息</h2>
      <p>我们会采取与个人信息处理风险相适应的安全技术和管理措施，包括访问权限控制、身份验证、数据分类管理、安全审计、异常监测、人员权限管理和安全事件应急处理等，努力防止个人信息遭到未经授权的访问、泄露、篡改、丢失或损坏。</p>
      <p>互联网环境并非绝对安全。如果发生或可能发生个人信息安全事件，我们将依法采取补救措施，并根据法律法规要求向您告知事件情况、可能影响、已采取或将采取的措施以及您可以自主防范的建议。</p>
    </section>

    <section>
      <h2>八、您的个人信息权利</h2>
      <p>在法律法规规定的范围内，您对自己的个人信息享有知情、决定、限制或拒绝处理、查阅、复制、更正、补充、删除、撤回同意和注销账号等权利。</p>
      <ol>
        <li><strong>查阅和更正</strong>：您可以通过应用内的个人中心或设置页面查看部分账号信息。如信息不准确或不完整，您可以通过第十三条的方式联系我们更正或补充。</li>
        <li><strong>删除个人信息</strong>：当处理目的已实现、无法实现或不再必要，或我们停止提供服务、保存期限届满、您撤回同意，或我们违反法律法规或与您的约定处理个人信息时，您可以依法请求删除。</li>
        <li><strong>撤回同意和权限</strong>：您可以在系统设置中关闭麦克风、位置、摄像头、通讯录、电话和存储等权限。您也可以通过第十三条的方式联系我们撤回其他授权。</li>
        <li><strong>注销账号</strong>：您可以进入应用“首页”，点击页面中央的球形主功能入口，在展开的功能球中依次点击“支持—用户中心—用户设置—注销账号”，查看《账号注销须知》。当前在线注销服务暂未开通，您可以通过注销页面的“联系客服”入口联系我们提交注销申请。账号注销后原则上无法恢复，请您在申请前妥善处理未完成业务及账号资产。</li>
        <li><strong>响应您的请求</strong>：为保障账号和信息安全，我们可能需要您提供必要信息以验证身份。我们将在法律法规规定的期限内处理您的合理请求。</li>
      </ol>
      <p>对于无端重复、需要过多技术手段、给他人合法权益带来风险，或法律法规规定可以不予响应的请求，我们可能无法完全满足，但会向您说明原因。</p>
    </section>

    <section>
      <h2>九、敏感个人信息的处理</h2>
      <p>本应用可能在特定功能中处理您的 <strong>精确位置、语音或音频、通讯录、通信内容、账号密码、虚拟资产或余额信息</strong>。泄露或不当使用这些信息，可能对您的人身、财产、人格尊严或其他权益造成较高风险。</p>
      <p>我们仅会在具有特定目的和充分必要性、并采取严格保护措施的情形下处理敏感个人信息，并会通过功能说明、系统权限弹窗或其他显著方式告知处理的必要性和对您权益的影响，并在法律法规要求时征得您的单独同意。</p>
    </section>

    <section>
      <h2>十、未成年人个人信息保护</h2>
      <p>如您是未满十八周岁的未成年人，应在父母或其他监护人的陪同和指导下阅读本政策，并在取得监护人同意后使用本服务。</p>
      <p>如您是未满十四周岁的未成年人，请不要在未经监护人同意的情况下向我们提供个人信息。如我们发现在未取得监护人同意的情况下收集了不满十四周岁未成年人的个人信息，我们将尽快删除或采取其他合法的处理措施。</p>
      <p>监护人如对所监护未成年人的个人信息处理有疑问，可以通过第十三条的方式联系我们。</p>
    </section>

    <section>
      <h2>十一、业务转让与运营主体变更</h2>
      <p>如发生合并、分立、解散、被宣告破产、资产或业务转让等导致个人信息需要转移的情形，我们将向您告知接收方的名称和联系方式，并要求接收方继续受本政策约束。如接收方变更原有的处理目的或处理方式，其将按照法律法规要求重新征得您的同意。</p>
    </section>

    <section>
      <h2>十二、本政策的更新</h2>
      <p>我们可能根据功能调整、技术变化、第三方服务更新、法律法规或监管要求修订本政策。</p>
      <p>如修订可能对您的权益产生重大影响，我们将通过应用内弹窗、页面提示、公告或其他显著方式向您说明。如法律法规要求重新征得同意，我们会在取得您的明确同意后再按照更新后的政策处理相关个人信息。</p>
    </section>

    <section>
      <h2>十三、如何联系我们</h2>
      <p>个人信息处理者：<strong>宇宙之幂（深圳）科技集团有限公司</strong></p>
      <p>如您对本政策、个人信息处理或您的个人信息权利有任何问题、意见、建议、投诉或注销请求，可以通过以下方式联系我们：</p>
      <ul>
        <li>电子邮箱：<strong><a href="mailto:universepower@universepower.cn">universepower@universepower.cn</a></strong></li>
        <li>问题反馈：进入应用“首页”，点击页面中央的球形主功能入口，在展开的功能球中依次点击“支持—用户中心—问题反馈”</li>
        <li>联系我们：进入应用“首页”，点击页面中央的球形主功能入口，在展开的功能球中依次点击“支持—用户中心—用户设置—联系我们”</li>
      </ul>
      <p>我们会在收到您的请求并完成必要的身份验证后，在法律法规规定的期限内予以处理和回复。</p>
    </section>

    <p>请您再次确认，您已阅读、理解并同意本政策的全部内容。</p>
  </legal-page>
</template>

<script>
import LegalPage from '@/components/main/legal/LegalPage'

export default {
  name: 'PrivacyPolicy',
  components: {
    LegalPage
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main/privacyPolicy.vue